import { render, staticRenderFns } from "./cable.vue?vue&type=template&id=cc98355c&scoped=true"
var script = {}
import style0 from "./cable.vue?vue&type=style&index=0&id=cc98355c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc98355c",
  null
  
)

export default component.exports